import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';
import { CONTENT_PAGE_LIST } from '../../data/contentPages';

const ContentHubPage = () => {
  const breadcrumbs = [
    {
      name: 'Pradžia',
      path: '/',
    },
    {
      name: 'Mokymosi gidai',
      path: '/mokymosi-gidai',
    },
  ];

  return (
    <>
      <SEO
        title="Mokymosi gidai tėvams ir pedagogams | SmartPanda"
        description="Praktiniai mokymosi gidai tėvams ir pedagogams: kaip padėti vaikui mokytis, lavinti dėmesį, formuoti mokymosi įpročius ir mokytis žaidžiant."
        canonical="/mokymosi-gidai"
        pageType="CollectionPage"
        breadcrumbs={breadcrumbs}
        includeWebsiteSchema={false}
        about={[
          'vaikų mokymasis',
          'mokymosi įpročiai',
          'vaikų edukacija',
          'mokymasis žaidžiant',
        ]}
      />

      <main className="sp-seo-page">
        <nav
          className="sp-seo-breadcrumbs"
          aria-label="Navigacija"
        >
          <div className="sp-seo-container">
            <Link to="/">Pradžia</Link>
            <span aria-hidden="true">→</span>
            <span>Mokymosi gidai</span>
          </div>
        </nav>

        <section
          className="sp-seo-hero"
          style={{ '--sp-accent': '#58CC02' }}
        >
          <div className="sp-seo-container">
            <div className="sp-seo-eyebrow">
              TĖVAMS IR PEDAGOGAMS
            </div>

            <h1>Mokymosi gidai vaikams: praktiniai patarimai tėvams</h1>

            <p className="sp-seo-intro">
              Praktinė informacija apie vaikų mokymąsi, dėmesį,
              mokymosi įpročius ir mokymąsi žaidžiant. Čia rasite
              aiškius patarimus, kuriuos galima pritaikyti kasdienėje
              veikloje su vaiku.
            </p>

            <div className="sp-seo-hero-actions">
              <Link
                to="/mokomieji-zaidimai"
                className="sp-seo-primary-btn"
              >
                Mokomieji žaidimai →
              </Link>

              <a
                href="#gidai"
                className="sp-seo-secondary-btn"
              >
                Peržiūrėti gidus
              </a>
            </div>
          </div>
        </section>

        <section
          id="gidai"
          className="sp-seo-section"
        >
          <div className="sp-seo-container">
            <div className="sp-seo-section-heading">
              <span>📚</span>
              <h2>Mokymosi gidai</h2>
            </div>

            <div className="sp-seo-related-grid">
              {CONTENT_PAGE_LIST.map((page) => (
                <Link
                  key={page.slug}
                  to={`/mokymosi-gidai/${page.slug}`}
                  className="sp-seo-related-card"
                >
                  <strong>{page.h1}</strong>
                  <span>{page.description}</span>
                  <span>Skaityti gidą →</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="sp-seo-section">
          <div className="sp-seo-container">
            <div className="sp-seo-content-block">
              <h2>Mokymasis gali būti įdomus</h2>

              <p>
                Vaikams lengviau įsitraukti į mokymąsi, kai jie gali
                praktiškai išbandyti naujus dalykus, spręsti užduotis
                ir gauti aiškų grįžtamąjį ryšį.
              </p>

              <Link
                to="/mokomieji-zaidimai"
                className="sp-seo-primary-btn"
              >
                Atrasti mokomuosius žaidimus →
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default ContentHubPage;
